
import { HttpOrgServiceList } from '@/service/basicdata';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
// import mixin from "./mixin";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpOrgServiceList,
        handleOperates(params, type) {
            switch (type) {
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/orgCarrierService/export", this.formData, { executor: 'request', download: true });
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, orgId } = row;
            return [
                {
                    label: this.$t('global.common.query'),
                    to: {
                        name: "basicdataOrganizationUpdate",
                        params: {
                            type: 'query',
                        },
                        query: { id, orgId }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    params: id,
                    show: true,
                    to: {
                        name: "basicdataOrganizationUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id, orgId }
                    },
                },
            ];
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getNextOrgList', 'getProductList', 'getWarehouseList','getSystemWareList']),

        ToolsData() {
            return [
                {
                    label: this.$t('global.common.operate_add', { defaultValue: "添加" }),
                    theme: "primary",
                    to: {
                        name: "basicdataOrganizationUpdate",
                        params: {
                            type: 'add'
                        }
                    }
                },
                {
                    label: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.alloment.client_organization', { defaultValue: "客户" }),
                    key: 'EQ_orgId',
                    tag: 'vSelect',
                    show: true,
                    options: this.getNextOrgList,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.carrier_code', { defaultValue: "承运商代码" }),
                    key: 'EQ_carrierCode',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: "承运商服务代码" }),
                    key: 'EQ_carrierServiceCode',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_warehouseId',
                    tag: 'vSelect',
                    options: this.getSystemWareList,
                    props:{
                        filterable:true,
                    }
                },
                // {
                //     label: "是否测算",
                //     key: 'EQ_active',
                //     tag: 'vSelect',
                //     options: this.getCalcList,
                // },
                {
                    label:  this.$t('fbb.bill.freeze_createdat', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    style: "width:200px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.operate', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: "客户" }),
                    key: 'orgId',
                    render: (h, { row }) => this.findRenderLabel(this.getNextOrgList, row.orgId)
                },
                // {
                //     title: '是否测算',
                //     key: 'active',
                //     render: (h, { row }) => this.findRenderLabel(this.getCalcList, row.active)
                // },
                // {
                //     title: '仓库',
                //     key: 'warehouseId',
                //     render: (h, { row }) => this.findRenderLabel(this.getWarehouseList, row.warehouseId)
                // },
                // {
                //     title: '承运商服务',
                //     key: 'carrierServiceCode',
                // },
                {
                    title: this.$t('fbb.organization.updater', { defaultValue: "更新人" }),
                    key: 'updatedName',
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: "更新时间" }),
                    key: 'updatedAt',
                }];
        },
    },
};




